'use client';

import type React from 'react';
import type { AppDetail } from '../utils/home.types';
import { Card } from '@yaradigitallabs/ahua-react';
import { useNavigate } from 'react-router-dom';

interface AppCardProps {
  app: AppDetail;
}

const AppCard: React.FC<AppCardProps> = ({ app }) => {
  const navigate = useNavigate();
  const handleCardNavigation = () => {
    if (app.link.startsWith('http')) {
      window.open(app.link, '_blank');
      return;
    } else {
      navigate(app.link);
    }
  };
  return (
    <Card key={app.id} className="flex! flex-col! justify-between!">
      <Card.Body>
        <Card.Media src={app.thumbnail} placeholder="No image found" />
        <Card.Content title={app.title} description={app.description} />
      </Card.Body>
      <section aria-label="section-divider">
        <Card.Divider />
        <Card.Tail className="flex flex-row justify-end!">
          <Card.Action
            label="Open"
            variant="ghost"
            className={`flex-none!`}
            disabled={app.disabled}
            {...(app.disabled ? {} : { onClick: handleCardNavigation })}
          />
        </Card.Tail>
      </section>
    </Card>
  );
};

export default AppCard;
